import { 
        USER_TOKEN_FIELD_NAME,
		USER_STORAGE_FIELD_NAME,
        TOKEN_COOKIE_OPTIONS,
        COLLAPSED_ITEMS_FIELD_NAME
} from '../global/constants.js';

import Cookies from 'js-cookie';

class UserManager {
    constructor() {
        if ( !UserManager.instance ) {
            this.user = false;
            this.preferences = [];

            if ( this.userLoggedIn() ) {
                this.user = this.getUserFromStorage();
                this.preferences = this.getPreferences();
            }

            this.getTokenFromCookies();
        }
    }

    setUser(newUser=false) {
        if ( newUser ) {
            this.user = newUser;
        }
    }

    getUser() {
        return this.user;
    }

    getUserId() {
        return this.user.id;
    }

    getUserToken() {
        return this.getTokenFromCookies();
    }

    userLoggedIn() {
        return this.getTokenFromCookies() !== false;
    }

    getUserFromStorage() {
		return window.localStorage.getItem(USER_STORAGE_FIELD_NAME) !== null ? 
				JSON.parse(window.localStorage.getItem(USER_STORAGE_FIELD_NAME)) 
				: false;
	}

    getTokenFromCookies() {
        const authToken = Cookies.get(USER_TOKEN_FIELD_NAME);
        return authToken !== undefined ?
                authToken
                : false;
    }

    saveTokenCookie(token='') {
        Cookies.set(USER_TOKEN_FIELD_NAME, token, TOKEN_COOKIE_OPTIONS,);
    }

	saveUser() {
        this.saveTokenCookie(this.user.token);
        delete this.user.token;
        window.localStorage.setItem(USER_STORAGE_FIELD_NAME, JSON.stringify(this.user));
	}

	deleteUser() {
		window.localStorage.removeItem(USER_STORAGE_FIELD_NAME);
        Cookies.remove(USER_TOKEN_FIELD_NAME);
        this.user = false;
	}

    login(newUser=false) {
        if ( newUser ) {
            this.setUser(newUser);
            this.saveUser();
        }
    }

    addCollapsedItem(id=-1) {
        this.preferences.push(id);
        this.savePreferences();
    }

    removeCollapsedItem(id=-1) {
        this.preferences = this.preferences.filter(item => item !== id);
        this.savePreferences();
    }

    hasCollapsedItem(id=-1) {
        return this.preferences.indexOf(id) !== -1;
    }

    savePreferences() {
        window.localStorage.setItem(COLLAPSED_ITEMS_FIELD_NAME, JSON.stringify(this.preferences));
    }

    getPreferences() {
        return window.localStorage.getItem(COLLAPSED_ITEMS_FIELD_NAME) !== null ?
                JSON.parse(window.localStorage.getItem(COLLAPSED_ITEMS_FIELD_NAME))
                : []
    }
}

const userManager = new UserManager();
export default userManager;